const MASS_FRAC_TYPE = 'ComponentMassFrac';
const MASS_FRAC_MAP_DEFS = [
    { mapKey: 'expression', nestedKey: 'expression' },
    { mapKey: 'minValue', nestedKey: 'minValue' },
    { mapKey: 'maxValue', nestedKey: 'maxValue' },
    { mapKey: 'uom', nestedKey: 'uom' },
    { mapKey: 'value', nestedKey: 'value' }
];

const isObj = (x) => x && typeof x === 'object' && !Array.isArray(x);
const deepCloneJson = (x) => (x != null ? JSON.parse(JSON.stringify(x)) : x);

const setMaybe = (keepNullKeys, obj, k, v) => {
    if (keepNullKeys || (v !== null && v !== undefined)) obj[k] = (v === undefined ? null : v);
};

const unionKeys = (...objs) => {
    const s = new Set();
    for (const o of objs) if (isObj(o)) Object.keys(o).forEach(k => s.add(k));
    return Array.from(s);
};

const mapDtoAttrs = (dto, mapAttr) => {
    if (!dto || typeof dto !== 'object') return dto;
    if (Array.isArray(dto.inputAttributes)) dto.inputAttributes = dto.inputAttributes.map(mapAttr);
    if (Array.isArray(dto.outputAttributes)) dto.outputAttributes = dto.outputAttributes.map(mapAttr);
    return dto;
};

const transformDtoForSaveOrUpdate = (dto, opts) => {
    const keepNullMapKeys = opts && typeof opts.keepNullMapKeys === 'boolean' ? opts.keepNullMapKeys : true;

    const clone = deepCloneJson(dto);
    if (!clone) return clone;

    const mapAttr = (a) => {
        if (!a || a.type !== MASS_FRAC_TYPE) return a;
        if (!isObj(a.value)) return a;

        const v = a.value;
        const looksUi = Object.values(v).some(isObj);
        if (!looksUi) return a; // már API forma

        const keys = Object.keys(v);
        const outMaps = {};
        for (const def of MASS_FRAC_MAP_DEFS) outMaps[def.mapKey] = {};

        for (const k of keys) {
            const raw = v[k];
            const item = isObj(raw) ? raw : {};
            for (const def of MASS_FRAC_MAP_DEFS) {
                let val = Object.prototype.hasOwnProperty.call(item, def.nestedKey) ? item[def.nestedKey] : null;
                if (def.mapKey === 'value' && !isObj(raw) && raw !== undefined) val = raw;
                setMaybe(keepNullMapKeys, outMaps[def.mapKey], k, val);
            }
        }

        return { ...a, ...outMaps };
    };

    return mapDtoAttrs(clone, mapAttr);
};

const transformDtoFromLoad = (dto, opts) => {
    const keepNullMapKeys = opts && typeof opts.keepNullMapKeys === 'boolean' ? opts.keepNullMapKeys : true;

    const clone = deepCloneJson(dto);
    if (!clone) return clone;

    const mapAttr = (a) => {
        if (!a || a.type !== MASS_FRAC_TYPE) return a;
        if (!isObj(a.value)) return a;

        const vObj = a.value;
        const looksUi = Object.values(vObj).some(isObj);
        const looksApi = Object.values(vObj).every(v => !isObj(v));
        if (looksUi) return a;
        if (!looksApi) return a;

        const maps = {};
        for (const def of MASS_FRAC_MAP_DEFS) maps[def.mapKey] = isObj(a[def.mapKey]) ? a[def.mapKey] : null;

        const keys = unionKeys(...Object.values(maps));
        const nested = {};

        for (const k of keys) {
            let allNull = true;
            const entry = {};
            for (const def of MASS_FRAC_MAP_DEFS) {
                const m = maps[def.mapKey];
                const val = m && Object.prototype.hasOwnProperty.call(m, k) ? m[k] : null;
                entry[def.nestedKey] = val === undefined ? null : val;
                if (entry[def.nestedKey] !== null && entry[def.nestedKey] !== undefined) allNull = false;
            }
            if (!keepNullMapKeys && allNull) continue;
            nested[k] = entry;
        }

        const cleared = {};
        for (const def of MASS_FRAC_MAP_DEFS) if (def.mapKey !== 'value') cleared[def.mapKey] = null;

        return { ...a, ...cleared, value: nested };
    };

    return mapDtoAttrs(clone, mapAttr);
};

const ModelEditTransform = {
    MASS_FRAC_TYPE,
    MASS_FRAC_MAP_DEFS,
    transformDtoForSaveOrUpdate,
    transformDtoFromLoad
};

export default ModelEditTransform;